<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="30%"
    append-to-body
    :before-close="handleClose"
  >
    <div
      slot="title"
      class="header-title"
      :style="{
        padding: '15px 20px',
        'box-sizing': 'border-box',
        backgroundColor: isCustom
          ? customColor
          : isSimple
          ? '#FD9112'
          : '#185ED3',
      }"
    >
      <div>新增手动标签</div>
    </div>
    <div class="bj">
      <div style="width: 100px">手动标签：</div>
      <el-autocomplete
        v-model="label"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入内容"
        @select="handleSelect"
      >
        <template slot-scope="{ item }">
          <div class="name">{{ item.value }}<span v-if="item.class" class="name"> ({{ item.class }})</span></div>
          
        </template>
      </el-autocomplete>

      <!-- <el-button :style="{'marginLeft':'30px','border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" v-if="options.length == 0 && label">新增</el-button> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        :style="{
          border: 'none',
          backgroundColor: isCustom
            ? customColor
            : isSimple
            ? '#FD9112'
            : '#185ED3',
        }"
        type="primary"
        @click="changeDesc"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { list } from "@/api/customLabel";
export default {
  props: ["dialogVisible"],
  watch: {
    dialogVisible: {
      deep: true,
      handler(v) {
        this.dialogVisible = v;
      },
    },
  },
  data() {
    return {
      label: "",
      options: [],
    };
  },
  methods: {
    handleClose() {
      this.label = "";
      this.$emit("handleClose");
    },
    changeDesc() {
      this.$emit("changeDesc", this.label);
      setTimeout(() => {
        this.label = "";
      }, 4000);
    },
    async getList(val, cb) {
      let { status, data, message, errors } = await list(val);
      if (status) {
        this.options = [];
        data.forEach((e) => {
          this.options.push({
            value: e.labelName,
            label: e.labelName,
            class: e.labelClass
          });
        });

        cb(this.options);
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    querySearchAsync(queryString, cb) {
      this.getList({ pageSize: 100, keyword: queryString }, cb);
      // var restaurants = this.options;
      // var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      // var restaurants = this.restaurants;
      // var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      //   cb(results);
      // }, 3000 * Math.random());
    },
    handleSelect(item) {
      console.log(item);
    },
  },
  created() {
    list({ pageSize: 100 }).then((e) => {
      this.options = [];
      e.data.forEach((res) => {
        this.options.push({
          value: res.labelName,
          label: res.labelName,
          class: e.labelClass
        });
      });
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.bj {
  display: flex;
  align-items: center;
}
</style>